/**
 * Browser-related utilities
 */

import { keys } from "./object";

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

export function isBrowser() {
  return typeof window !== "undefined";
}

function getAppContentWidth(): number {
  if (!isBrowser()) return 1280;
  const assistantWidth =
    Number.parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--mixitone-assistant-width"),
    ) || 0;
  return window.innerWidth - assistantWidth;
}

export function getCurrentBreakpoint(): keyof typeof breakpoints {
  if (!isBrowser()) return "md";
  const width = getAppContentWidth();
  return keys(breakpoints).find((key: keyof typeof breakpoints) => width < breakpoints[key]) || "xl";
}

export function isGreaterThanBreakpoint(breakpoint: keyof typeof breakpoints) {
  return breakpoints[getCurrentBreakpoint()] > breakpoints[breakpoint];
}

export function getStackTrace() {
  const error = new Error();
  const trace = error?.stack?.split("\n").slice(3);
  return trace || [];
}

export function wwwUrl(path: string) {
  return `${import.meta.env.VITE_WWW}/${path}`;
}

const DEFAULT_BROWSER_TIMEZONE = "Pacific/Auckland";

/** IANA timezone from the current browser, or Pacific/Auckland if unavailable. */
export function browserTimeZone(): string {
  if (!isBrowser()) return DEFAULT_BROWSER_TIMEZONE;
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone?.trim();
    return zone || DEFAULT_BROWSER_TIMEZONE;
  } catch {
    return DEFAULT_BROWSER_TIMEZONE;
  }
}
